module.exports = __webpack_public_path__ + "static/full-image-4abd5d9bb74165ffe9ad3657d518df73.jpg";